import { render, staticRenderFns } from "./EligibleAccountError.vue?vue&type=template&id=67c87d75&scoped=true"
import script from "./EligibleAccountError.vue?vue&type=script&lang=js"
export * from "./EligibleAccountError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c87d75",
  null
  
)

export default component.exports